var _rect, _circle, _path, _circle2, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_18",
    "data-name": "Gruppe 18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9",
    "data-name": "Rechteck 9",
    width: 71,
    height: 71,
    transform: "translate(0 0)",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(35 35)",
    fill: "#bcb243"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M45.526,6.932H36.093a8.863,8.863,0,0,0-16.729,0H9.932A5.95,5.95,0,0,0,4,12.864V57.356a5.95,5.95,0,0,0,5.932,5.932H28.055a20,20,0,0,1-4.212-5.932H9.932V12.864h5.932v8.9H39.593v-8.9h5.932V27.932a20.853,20.853,0,0,1,5.932,1.78V12.864A5.95,5.95,0,0,0,45.526,6.932Z",
    transform: "translate(7.864 1.966)",
    fill: "#bcb243"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(33 9)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_10",
    "data-name": "Rechteck 10",
    width: 2.771,
    height: 6.928,
    transform: "translate(43.496 50.678)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_11",
    "data-name": "Rechteck 11",
    width: 2.771,
    height: 4.157,
    transform: "translate(49.038 53.449)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_12",
    "data-name": "Rechteck 12",
    width: 2.771,
    height: 2.771,
    transform: "translate(49.038 47.907)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_13",
    "data-name": "Rechteck 13",
    width: 2.771,
    height: 13.856,
    transform: "translate(54.581 43.75)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogfile);
export default __webpack_public_path__ + "static/media/icon-logfile.95e66a649487b260f7c2915b37cc8d6f.svg";
export { ForwardRef as ReactComponent };